/* App.js */
import React, { Component } from 'react';
import CanvasJSReact from '@canvasjs/react-charts';

//var CanvasJSReact = require('@canvasjs/react-charts');
 
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
 
class Medicalchart extends Component {	
	  constructor(props) {
        super(props);
        this.state = { dataPoints: [], isLoaded: false };
    }
	componentDidMount() {
        fetch('https://thekandnsway.pk/ci2/index.php/user/medicalchart/101026')
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                var dps = [];
                for (var i = 0; i < data.length; i++) {
                    dps.push({
                        label: data[i].mmonth,
                        y: data[i].Totamt
                    });
                }
                this.setState({
                    isLoaded: true,
                    dataPoints: dps
                });
            });
    }

	render() {
		console.log(this.state.dataPoints);
		let datapoints=this.state.dataPoints;
		
		const options = {
			animationEnabled: true,
			exportEnabled: true,
			theme: "dark2", // "light1", "dark1", "dark2"
			title:{
				text: "Trip Expenses"
			},
			data: [{
				type: "pie",
				indexLabel: "{label}: {y}%",		
				startAngle: -90,
				dataPoints:this.state.dataPoints
//                xValueFormatString: "",
//                yValueFormatString: "#,##0.00",
/*                dataPoints: [	{ y: 20, label: "Airfare" },
					{ y: 24, label: "Food & Drinks" },
				
					{ y: 10, label: "Misc" }	]*/ 
            }]
        }
        return (
            <div>
                {this.state.isLoaded && <CanvasJSChart options={options}
                    onRef={ref => this.chart = ref}
                />}
                {/*You can get reference to the chart instance as shown above using onRef. This allows you to access all chart properties and methods*/}
            </div>
		);
	}
}
 
export default Medicalchart;                  